import Container from "@client/content/Containers/container";
import { getContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import { VimeoVideo, WistiaVideo, YouTubeVideo } from "@client/controls/Video/component";
import { type AspectRatio } from "@common/controls/AspectRatioContainer/lib";
import * as React from "react";

import "./style.less";

export type VideoComponentProps = RootContainerProps & {
  aspectRatio: AspectRatio;
  autoPlay: boolean;
  loop: boolean;
  mute: boolean;
  showControls: boolean;
  type: "file" | "youtube" | "vimeo" | "wistia";
  vimeoId: string;
  youTubeId: string;
  wistiaId: string;
};

export default ({ vimeoId, wistiaId, youTubeId, type, ...props }: VideoComponentProps) => (
  <Container className="wsc_content_video" {...getContainerProps(props)}>
    {type === "youtube" && <YouTubeVideo allowFullScreen isBackground={false} videoId={youTubeId} {...props} />}
    {type === "vimeo" && <VimeoVideo allowFullScreen videoId={vimeoId} isBackground={false} {...props} />}
    {type === "wistia" && <WistiaVideo allowFullScreen videoId={wistiaId} isBackground={false} {...props} />}
  </Container>
);
